import clsx from 'clsx';
import { FC } from 'react';
import { cvaWrapper } from '~/shared/ui/Wrapper/WrapperStyles';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Wrapper: FC<Props> = ({ children, className }) => {
  return <div className={clsx(cvaWrapper(), className)}>{children}</div>;
};
